import Trashed from '@/views/borrows/trashes/Index'
import List from '@/views/borrows/trashes/List'
import Show from '@/views/borrows/trashes/Show'
import Permissions from '@/permissions'

export const trashedRouters = {
  path: 'trashed',
  name: 'trashed',
  component: Trashed,
  redirect: 'trashed',
  meta: {
    permissions: [Permissions.backend.trashed.manage],
    groups: 'trashed'
  },
  children: [
    {
      path: '',
      name: 'list-trashed',
      component: List,
      meta: {
        permissions: [Permissions.backend.trashed.list],
        groups: 'trashed',
        breadcrumb: [
          {
            name_en: 'Trashed',
            name_km: 'ដែលបានលុប'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'show/:borrow_id',
      name: 'show-trashed',
      component: Show,
      meta: {
        permissions: [Permissions.backend.trashed.show],
        groups: 'trashed',
        breadcrumb: [
          {
            name_en: 'Trashed',
            name_km: 'ដែលបានលុប'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    }
  ]
}
